<!--
  功能：功能描述
  作者：jiangyongqiang
  邮箱：missfoxw@163.com
  时间：2023年10月19日 11:29:41
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <ul class="price-list px-4 py-2" :style="{ backgroundColor: bgColor }">
    <li>
      <span
        class="fb-650"
        :style="labelStyle"
        v-if="store?.userInfo?.status == 1"
      >
        $ {{ $Utils.addThousandSeparator(priceInfo.productPrice, false) }} ea ×
        {{ priceInfo.productQuantity || 0 }} qty
      </span>
      <span class="fb-650" :style="labelStyle" v-else>
        $
        {{
          $Utils.addThousandSeparator(priceInfo.productPrice, false)
        }}&nbsp;(C)&nbsp;ea × {{ priceInfo.productQuantity || 0 }} qty
      </span>
      <em :style="fieldStyle" v-if="priceInfo.productQuantity">
        $
        {{
          $Utils.addThousandSeparator(
            $Utils.pointDigit(
              priceInfo.productPrice,
              priceInfo.productQuantity
            ),
            false
          )
        }}
      </em>
    </li>
    <li v-show="!hasBlankOrSample">
      <span
        class="fb-650"
        :style="labelStyle"
        v-if="store?.userInfo?.status == 1"
        >Set-Up Charge</span
      >
      <span class="fb-650" :style="labelStyle" v-else
        >Set-Up Charge&nbsp;(G)</span
      >
      <em
        :style="fieldStyle"
        v-if="$Utils.addThousandSeparator(priceInfo.setUpCharge || 0)"
        >$ {{ $Utils.addThousandSeparator(priceInfo.setUpCharge || 0) }}</em
      >
    </li>
    <section v-if="priceInfo?.additionalCharges">
      <div v-if="isShowAdditional(priceInfo.additionalCharges)">
        <li>
          <span
            class="fb-650"
            :style="labelStyle"
            v-if="store?.userInfo?.status == 1"
            >Additional Charges</span
          >
          <span class="fb-650" :style="labelStyle" v-else
            >Additional Charges&nbsp;(C)</span
          >
        </li>
        <li
          v-if="Array.isArray(priceInfo.additionalCharges.addprice)"
          class="fs-12"
          v-for="(item, i) in priceInfo.additionalCharges.addprice.filter(
            item => item.specsPrice > 0
          ) || []"
          :key="i"
        >
          <span class="pl-4" :style="labelStyle"
            >{{ item.specsType }}:{{ item.specsValue }}</span
          >
          <em :style="fieldStyle"
            >$ {{ $Utils.addThousandSeparator(item.specsPrice || 0) }}</em
          >
        </li>
      </div>
      <li v-show="priceInfo.additionalCharges.imprint > 0 && !hasBlankOrSample">
        <span class="pl-4" :style="labelStyle">Imprint</span>
        <em :style="fieldStyle">
          $
          {{
            $Utils.addThousandSeparator(
              priceInfo.additionalCharges.imprint || 0
            )
          }}
        </em>
      </li>
    </section>
    <li v-show="priceInfo.physicalSample > 0 && sampleFlag">
      <span
        class="fb-650"
        :style="labelStyle"
        v-if="store?.userInfo?.status == 1"
        >Physical Sample</span
      >
      <span class="fb-650" :style="labelStyle" v-else
        >Physical Sample&nbsp;(C)</span
      >
      <em :style="fieldStyle"
        >$ {{ $Utils.addThousandSeparator(priceInfo.physicalSample || 0) }}</em
      >
    </li>
    <li v-if="!hasShippingZipcode" class="position-relative">
      <span :style="labelStyle" class="fb-650">
        Shipping Charge

        <shopmall-tip
          v-if="hasShippingTips"
          max-width="360"
          message="The shipping charge shown is an estimate; the actual cost will be determined at checkout."
          location="right"
          :size="22"
          color="#666"
          icon="mdi-help-circle-outline"
        ></shopmall-tip>
      </span>
      <em
        :style="fieldStyle"
        v-if="!priceInfo.shippingCharge && priceInfo.shippingCharge != 0"
      >
        <span :class="{ 'zip-code-tip': showZipCodeHint }">
          {{ showZipCodeHint ? "Please enter ZIP Code" : "--" }}</span
        >
      </em>
      <em :style="fieldStyle" v-else
        >$ {{ $Utils.addThousandSeparator(priceInfo.shippingCharge || 0) }}</em
      >
    </li>
    <!-- discount -->
    <li
      class="position-relative"
      v-if="showDiscount && priceInfo.discountAmount"
    >
      <span :style="labelStyle" class="fb-650">
        Discount
        <shopmall-tip
          max-width="360"
          message="Discounts are shown as estimated amounts; actual amounts may vary due to bundle purchases."
          location="right"
          :size="22"
          color="#666"
          icon="mdi-help-circle-outline"
          v-if="discountTip"
        ></shopmall-tip>
      </span>
      <em :style="fieldStyle" class="fc-red"
        >-$
        {{
          priceInfo.discountAmount ? priceInfo.discountAmount.toFixed(2) : 0
        }}</em
      >
    </li>

    <li class="total mt-2 fb-650">
      <span :style="labelStyle" class="d-flex align-center">
        <span style="width: auto">{{
          !hasShippingZipcode ? "Total" : "Subtotal"
        }}</span>
        <shopmall-tip
          v-if="hasShippingZipcode"
          max-width="360"
          message="Excluding Shipping"
          location="bottom"
          :size="22"
          color="#666"
          icon="mdi mdi-information-outline"
        ></shopmall-tip>
      </span>

      <em v-if="$Utils.addThousandSeparator(priceInfo.totalPrice || 0)">
        <small class="mr-1" :style="fieldStyle">$</small>
        <b :style="fieldStyle">{{
          showDiscount
            ? $Utils.addThousandSeparator(priceInfo.discountTotalPrice || 0)
            : $Utils.addThousandSeparator(priceInfo.totalPrice || 0)
        }}</b>
      </em>
    </li>

    <div v-show="hasShippingText" class="fs-13 fc-black-09 mt-3 tips">
      The shipping charge shown is an estimate; the actual cost will be
      determined at checkout.
    </div>
  </ul>
  <div class="loading-mask" v-if="loaddingStatus">
    <shopmall-text-loading />
  </div>
</template>

<script setup>
import { useUserStore } from "~/stores";
const { $Utils } = useNuxtApp();
const store = useUserStore();
const props = defineProps({
  priceInfo: {
    type: Object,
    default: () => {}
  },
  sampleFlag: {
    type: Boolean,
    default: false
  },
  hasBlankOrSample: {
    type: Boolean,
    default: false
  },
  bgColor: {
    type: String,
    default: "#FAFAFA"
  },
  labelStyle: {
    type: Object,
    default: () => ({})
  },
  fieldStyle: {
    type: Object,
    default: () => ({})
  },
  hasShippingTips: {
    type: Boolean,
    default: false
  },
  hasShippingZipcode: {
    type: Boolean,
    default: false
  },
  hasShippingText: {
    type: Boolean,
    default: false
  },
  loaddingStatus: {
    type: Boolean
  },
  showZipCodeHint: {
    type: Boolean
  },
  discountTip: {
    type: Boolean
  },
  showDiscount: {
    type: Boolean
  }
});
const postCode = ref(store?.zipCodeInfo?.postCode ?? "");
const residential = ref(store?.zipCodeInfo?.residential ?? false);
const isShowAdditional = data => {
  const addprice =
    data.addprice && data.addprice.filter(item => item.specsPrice > 0).length
      ? true
      : false;
  const imprint = data.imprint > 0 && !props.hasBlankOrSample;

  if (addprice || imprint) {
    return true;
  } else {
    return false;
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/product.scss";
.imprint-color {
  width: 24px;
  height: 24px;
}
.imprint-color-selected {
  width: 18px;
  height: 18px;
}
.tips {
  max-width: 360px;
}
.loading-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba($color: #fff, $alpha: 0.7);
  z-index: 99;
}
.zip-code-tip {
  color: rgb(217, 0, 27) !important;
  font-size: 12px;
}
</style>
